document.addEventListener('DOMContentLoaded', () => {
    const ugcCarousel = document.querySelector('[data-ugc-carousel]');
    const btnPrev = document.querySelector('[data-ugc-carousel-previous]');
    const btnNext = document.querySelector('[data-ugc-carousel-next]');


 // OPEN VIDEO
        
        const ugcLightbox = document.querySelector('[data-video-lightbox]');
        const ugcVideoEl = ugcLightbox.querySelector('[data-video-lightbox-video]');
        const ugcCloseBtn = ugcLightbox.querySelector('[data-video-lightbox-close]');


    if (!ugcCarousel) return;

    // Initialize Flickity
    const ugcflkty = new Flickity(ugcCarousel, {
        cellAlign: 'center',
        pageDots: true,
        adaptiveHeight: false,
        initialIndex: 1,
        prevNextButtons: false,
        wrapAround: true,
    });

    // Event delegation for buttons
    ugcCarousel.addEventListener('click', (e) => {
        // MEDIA TOGGLER + PLAY
        const toggler = e.target.closest('[data-media-toggler]');
        if (toggler) {
            const media = toggler.closest('[data-media]');
            if (!media) return;

            media.setAttribute('data-media', 'expanded');

            // ugcVideo points to the video inside this media
            const ugcVideo = media.querySelector('video');
            if (ugcVideo) {
                // Pause all other videos
                ugcCarousel.querySelectorAll('video').forEach(v => {
                    if (v !== ugcVideo) {
                        v.pause();
                        v.closest('[data-media]')?.classList.remove('is-playing');
                    }
                });

                ugcVideo.play();
                media.classList.add('is-playing');
            }
            return;
        }

        // VIDEO PLAY BUTTON
        const playBtn = e.target.closest('[data-review-video-play]');
        if (playBtn) {
            const media = playBtn.closest('[data-media]');
            if (!media) return;

            const ugcVideo = media.querySelector('video');
            if (!ugcVideo) return;

            // Pause all other videos
            ugcCarousel.querySelectorAll('video').forEach(v => {
                if (v !== ugcVideo) {
                    v.pause();
                    v.closest('[data-media]')?.classList.remove('is-playing');
                }
            });

            ugcVideo.play();
            media.classList.add('is-playing');
            return;
        }

        // VIDEO PAUSE BUTTON
        const pauseBtn = e.target.closest('[data-review-video-pause]');
        if (pauseBtn) {
            const media = pauseBtn.closest('[data-media]');
            if (!media) return;

            const ugcVideo = media.querySelector('video');
            if (!ugcVideo) return;

            ugcVideo.pause();
            media.classList.remove('is-playing');
            return;
        }

        
    
        const reviewBtns = e.target.closest('[data-review-video]');
        if (reviewBtns) {
            const src = reviewBtns.getAttribute('data-review-video');
            ugcPlayPauseBtn.classList.remove('is-paused');
            ugcMuteBtn.classList.remove('is-muted');
            ugcVideoEl.src = src;
            ugcVideoEl.play();
            ugcLightbox.classList.add('active');
        }   


        
    });


    ugcCloseBtn.addEventListener('click', closeVideo);
    ugcLightbox.addEventListener('click', (e) => {
      if (e.target === ugcLightbox) closeVideo();
    });

    function closeVideo() {
      ugcVideoEl.pause();
      ugcVideoEl.src = "";
      ugcLightbox.classList.remove('active');
    }


    // Button actions
    btnPrev.addEventListener('click', () => ugcflkty.previous());
    btnNext.addEventListener('click', () => ugcflkty.next());





    const ugcPlayPauseBtn = document.querySelector('[data-video-lightbox-play]');
    const ugcMuteBtn = document.querySelector('[data-video-lightbox-mute]');
    const ugcProgress = document.querySelector('[data-video-lightbox-progress]');

    // Play / Pause
    ugcPlayPauseBtn.addEventListener('click', () => {
      if (ugcVideoEl.paused) {
        ugcVideoEl.play();
        ugcPlayPauseBtn.classList.remove('is-paused');
      } else {
        ugcVideoEl.pause();
        ugcPlayPauseBtn.classList.add('is-paused');
      }
    });

    // Mute / Unmute
    ugcMuteBtn.addEventListener('click', () => {
      ugcVideoEl.muted = !ugcVideoEl.muted;
      ugcMuteBtn.classList.toggle('is-muted', ugcVideoEl.muted);
    });

    // Progress bar update
    ugcVideoEl.addEventListener('timeupdate', () => {
      if (ugcVideoEl.duration) {
        const percentage = (ugcVideoEl.currentTime / ugcVideoEl.duration) * 100;
        ugcProgress.value = percentage;

        ugcProgress.style.background = `linear-gradient(to right, rgb(255, 255, 255) 0%, rgb(255, 255, 255) ${percentage}%, rgba(0, 0, 0, 0.0) ${percentage}%, rgba(0, 0, 0, 0.0) 100%)`;
      }
    });

    // Seek via progress bar
    ugcProgress.addEventListener('input', () => {
      if (ugcVideoEl.duration) {
        const time = (ugcProgress.value / 100) * ugcVideoEl.duration;
        ugcVideoEl.currentTime = time;

      }
    });




});



